import { render, staticRenderFns } from "./FilterRecipesModal.vue?vue&type=template&id=18c33f0b&scoped=true&lang=pug"
import script from "./FilterRecipesModal.vue?vue&type=script&lang=js"
export * from "./FilterRecipesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c33f0b",
  null
  
)

export default component.exports